import React from 'react';
import PropTypes from 'prop-types';

const Resolution4KPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M28 20.99A3.006 3.006 0 0 1 24.992 24H7.008A3.002 3.002 0 0 1 4 20.99v-9.98A3.006 3.006 0 0 1 7.008 8h17.984A3.002 3.002 0 0 1 28 11.01v9.98zM18 15.02l2.26-3.018h2.544l-3.108 3.742L22.972 20H20.44l-2.1-3.01-.34.423V20h-2v-7.996h2v3.015zm-4 4.986v-1.5h1v-2h-1V12h-3.25L8 16.86v1.643h4v1.5h2zm-2-3.5h-1.7l1.7-2.901v2.9z"
    />
  );
};

Resolution4KPath.propTypes = {
  fill: PropTypes.string,
};

export default Resolution4KPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/technology/resolution-4k.jsx